import { useAppSelector } from 'src/redux/hooks';
import { GlobalState } from 'src/redux/store';

export const documentTypesSelector = (state: GlobalState) => state.documentTypes;

export const documentTypesSelectorData = (state: GlobalState) => documentTypesSelector(state).data;

export const useDocumentTypes = () => useAppSelector(documentTypesSelectorData);
